<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="true">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="productId" class="my-4">{{'lang.globals.product.edit' | translate}}</h3>
              <h3 *ngIf="!productId" class="my-4">{{'lang.globals.product.create' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="PLU">PLU</label>
                    <input type="text" id="PLU" class="form-control" formControlName="PLU">
                    <span class="form-text text-muted">{{'lang.globals.product.plu' | translate}}</span>
                    <div *ngIf="PLU.touched && PLU.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.description' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="GTIN">GTIN</label>
                    <input type="text" id="GTIN" class="form-control" formControlName="GTIN">
                    <span class="form-text text-muted">{{'lang.globals.product.gtin' | translate}}</span>
                    <div *ngIf="GTIN.touched && GTIN.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="ASIN">ASIN</label>
                    <input type="text" id="ASIN" class="form-control" formControlName="ASIN">
                    <span class="form-text text-muted">{{'lang.globals.product.asin' | translate}}</span>
                    <div *ngIf="ASIN.touched && ASIN.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.description' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                    <input type="text" id="Description" class="form-control" formControlName="Description">
                    <span class="form-text text-muted">{{'lang.planningEdit.description' | translate}}</span>
                    <div *ngIf="Description.touched && Description.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.description' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group d-grid">
                    <label class="form-label" for="Company">{{'lang.globals.company' | translate}}</label>
                    <button [disabled]="product?.manufacturer && productId" (click)="selectCompany()" type="button"
                            id="Company"
                            class="btn btn-secondary  text-center">
                      <sb-icon class="mr-1" icon="company"></sb-icon>
                      {{product?.manufacturer ? product?.manufacturer?.name : 'Default'}}
                    </button>
                  </div>
                </div>
              </div>
              <!-- todo gtin representation-->
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.products)"
                          type="button" class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</button>
                <button (click)="updateProductCall()" type="button" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
